'use client';
import { useEffect, useState } from 'react';
import { StreamingUnactivated } from '../streaming-item/streaming-unactived';
import { useStreamingStore } from '@/store/streaming';
import { VideoDeviceType, streamingService } from '@/services/streaming.service';
import { GVBase, IframeBase, VideoBase } from '.';
import { MatchModelBase } from '@nf/types/odds';
import { Chatroom } from '@/features/chatroom';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { LoadingIcon } from '@/components/icons/svg-icons';
import { streamingBaseStyle } from './streaming-base.style';
import clsx from 'clsx';

export const StreamingBase = ({ device, match }: { device?: VideoDeviceType, match?: MatchModelBase}) => {
	const [
		streamingType, 
		streamingSrc,
		streamingUrl,
		isPin,
		isMiniStreaming,
		isLoading,
		isEsport,
		setIsLoading
	] = useStreamingStore(state => [
		state.streamingType,
		state.streamingSrc,
		state.streamingUrl,
		state.isPin,
		state.isMiniStreaming,
		state.isLoading,
		state.isEsport,
		state.setIsLoading
	]);
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();

	useEffect(() => {
		if (!streamingUrl) {
			setIsLoading(true);
			setTimeout(() => {
				setIsLoading(false);
			}, 3000)
		} else {
			setIsLoading(false);
		}
	}, [streamingUrl]);

	const view = useAppearanceStore(state => state.view);
	const [gvkey, setGVKey] = useState(''); // 控制GV Refresh Key
	const MCDNStreamingList =['24', '25', '26', '27', '28'];
	if (isLoading) {
		return (
			<div className={clsx('streaming-loading', streamingBaseStyle.loading)}>
				<LoadingIcon />
			</div>
		)
	}
	
	if (['13', '19', '20', '21', '22', '23', '29'].indexOf(streamingSrc.split('-')[0]) > -1) {
		const realSrc = streamingSrc.split('-')[0];
		
		const params = {
			streamingSrc: streamingSrc,
			realSrc: realSrc,
			streamerExclusiveId: match && !!realSrc ? streamingService.getVideoInfo(match, SiteConfigsData, user, streamingSrc)?.siteId || 0 : 0,
			matchId: match ? match?.MatchId : 0,
			isPin: isPin,
			parentId: match ? match?.Parentid || 0 : 0,
		};
		return (
			<>
				{(!streamingUrl && streamingType) ? <StreamingUnactivated type="1" /> : <VideoBase device={device} />}
				{ SiteConfigsData?.EnableChatroom && match && ['20', '21', '22', '23', '29'].includes(realSrc) && view === ViewEnum.galaxy ? 
					<Chatroom params={params} /> 
					: null}
			</>
		);
	} else if (MCDNStreamingList.indexOf(streamingSrc.split('-')[0]) > -1) {
		const realSrc = streamingSrc.split('-')[0];
		const params = {
			streamingSrc: streamingSrc,
			realSrc: realSrc,
			streamerExclusiveId: match && !!realSrc ? streamingService.getVideoInfo(match, SiteConfigsData, user, streamingSrc)?.siteId || 0 : 0,
			matchId: match ? match?.MatchId : 0,
			isPin: isPin,
			parentId: match ? match?.Parentid || 0 : 0,
		};
		return (
			<>
				{/* 因串接sdk遇到版本不相容，暫時先用原本的VideoBase 播放*/}
				{(!streamingUrl && streamingType) ? <StreamingUnactivated type="1" /> : <VideoBase device={device} />}
				{ SiteConfigsData?.EnableChatroom && match && ['24', '25', '26', '27', '28'].includes(realSrc) && view === ViewEnum.galaxy ? 
					<Chatroom params={params} /> 
					: null}
			</>
		);
	} else {
		return <IframeBase />;
	}
	// } else if (streamingType === 'GV') {
	// 	return <GVBase match={match} />;
	// } else {
	// 	return <IframeBase />;
	// }
};
